import { A } from "@solidjs/router";
import { Show } from "solid-js";

export function BriefPreviewHeader(props: {
  websiteId: string;
  mapRequested: boolean;
  mapAvailable: boolean;
  issueRequested: boolean;
  issueAvailable: boolean;
  issueId: string | null;
}) {
  return (
    <>
      <header class="brief-page-head">
        <div>
          <div class="brief-title-line">
            <h1>Delivery briefs</h1>
            <span>Preview</span>
          </div>
          <p>
            Draft proposed work from Scan findings and agreed estate changes.
          </p>
        </div>
        <small>Preview changes are not saved.</small>
      </header>

      <Show when={props.mapRequested && !props.mapAvailable}>
        <section class="brief-session-note" role="status">
          <div>
            <strong>
              No accepted Map changes are available in this Preview session.
            </strong>
            <p>
              Map decisions reset on reload. Accept the change again to restore
              the handoff.
            </p>
          </div>
          <a href={`/w/${props.websiteId}/map`}>Return to Map</a>
        </section>
      </Show>
      <Show when={props.issueRequested && !props.issueAvailable}>
        <section class="brief-session-note" role="status">
          <div>
            <strong>
              This issue does not yet contain enough delivery detail to create a
              Brief.
            </strong>
            <p>
              Review its evidence and recommended action before handing it over.
            </p>
          </div>
          <Show when={props.issueId}>
            {(issueId) => (
              <A href={`/w/${props.websiteId}/scan/issues/${issueId()}`}>
                Return to issue
              </A>
            )}
          </Show>
        </section>
      </Show>
    </>
  );
}
